// @flow

import React, { useMemo } from 'react';
import styled from 'styled-components';

import { Nav as Data } from 'data/global/nav';
import { useNavState } from 'contexts';
import { Color, flex, Layout, maxWidthContainer } from 'styles';
import MenuGroup from './MenuGroup';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${Color.WHITE};
  z-index: ${Layout.Z_INDEX_MOBILE_MENU};
  transition: ${({ visible }) => (visible ? `transform 400ms linear` : `transform 0ms linear 10ms`)};
  transform: translateY(${({ visible }) => (visible ? 0 : '-100%')});
  overflow-y: auto;
  overflow-scrolling: touch;

  > div {
    padding-top: ${Layout.NAV_HEIGHT_MOBILE + 1}px;
    ${flex()};

    > div {
      ${maxWidthContainer()};
    }
  }
`;

const Buttons = styled.div`
  padding: 40px 0;

  > div {
    margin-bottom: 12px;
  }
`;

const MobileMenu = () => {
  const { showingMobileNav, renderMobile } = useNavState();
  return useMemo(
    () =>
      renderMobile ? (
        <Wrapper visible={showingMobileNav} aria-hidden={true}>
          <div>
            <div>
              {Data.map((data) => (
                <MenuGroup key={data.title} data={data} />
              ))}
              <Buttons />
            </div>
          </div>
        </Wrapper>
      ) : null,
    [renderMobile, showingMobileNav]
  );
};

export default MobileMenu;
